function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "style", "size", "weight", "display", "type", "children", "ellipsis", "disabled"],
  _excluded2 = ["level", "className", "children"],
  _excluded3 = ["className", "blank", "type", "size", "children", "ellipsis", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cn } from "../../../lib/utils";
import React from 'react';
import * as styles from "../../style/text";
import { jsx as _jsx } from "react/jsx-runtime";
var TEXT_STYLE = {
  color: {
    white: 'text-[var(--bds-static-white)]',
    title: 'text-[var(--bds-gray-t1-title)]',
    secondary: 'text-[var(--bds-gray-t2)]',
    success: 'text-[var(--bds-green-800-pressed)]',
    warning: 'text-[var(--bds-brand-700-normal)]',
    danger: 'text-[var(--bds-red-700-normal)]'
  },
  size: {
    12: styles.molyText12,
    14: styles.molyText14,
    16: styles.molyText16,
    18: styles.molyText18,
    20: styles.molyText20,
    24: styles.molyText24
  }
};
var Text = function Text(props) {
  var className = props.className,
    style = props.style,
    _props$size = props.size,
    size = _props$size === void 0 ? 14 : _props$size,
    _props$weight = props.weight,
    weight = _props$weight === void 0 ? '400' : _props$weight,
    _props$display = props.display,
    display = _props$display === void 0 ? 'inline' : _props$display,
    type = props.type,
    children = props.children,
    ellipsis = props.ellipsis,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  var newStyle = _objectSpread({}, style);
  if (ellipsis && typeof ellipsis !== 'boolean' && ellipsis.rows > 0) {
    newStyle.WebkitLineClamp = ellipsis.rows;
  }
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    className: cn('moly-text', type ? TEXT_STYLE.color[type] : '', TEXT_STYLE.size[size], "font-[".concat(weight, "]"), display, className, {
      'line-clamp-1': ellipsis
    }, disabled && 'text-[var(--bds-gray-t4-dis)] cursor-not-allowed'),
    style: newStyle
  }, otherProps), {}, {
    children: children
  }));
};
var Title = function Title(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded2);
  var style = _objectSpread(_objectSpread({}, props.style || {}), {}, {
    fontSize: "var(--bds-font-size-h".concat(level, ")"),
    lineHeight: "var(--bds-line-height-h".concat(level, ")")
  });
  if (level === 1) {
    return /*#__PURE__*/_jsx("h1", _objectSpread(_objectSpread({
      className: cn('text-[] leading-[var(--bds-line-height-h1)]', className)
    }, props), {}, {
      style: style,
      children: children
    }));
  }
  if (level === 2) {
    return /*#__PURE__*/_jsx("h2", _objectSpread(_objectSpread({
      className: cn(className)
    }, props), {}, {
      style: style,
      children: children
    }));
  }
  if (level === 3) {
    return /*#__PURE__*/_jsx("h3", _objectSpread(_objectSpread({
      className: cn(className)
    }, props), {}, {
      style: style,
      children: children
    }));
  }
  return /*#__PURE__*/_jsx("h1", _objectSpread(_objectSpread({
    className: cn(className)
  }, props), {}, {
    style: style,
    children: children
  }));
};
var Link = function Link(_ref2) {
  var className = _ref2.className,
    blank = _ref2.blank,
    type = _ref2.type,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 14 : _ref2$size,
    children = _ref2.children,
    ellipsis = _ref2.ellipsis,
    disabled = _ref2.disabled,
    props = _objectWithoutProperties(_ref2, _excluded3);
  var _props = _objectSpread({}, props);
  if (blank) {
    _props.target = '_blank';
  }
  if (disabled) {
    delete _props.href;
  }
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    className: cn('no-underline text-inherit', !disabled && 'hover:!text-[var(--bds-brand-600-hover)]', type ? TEXT_STYLE.color[type] : '', TEXT_STYLE.size[size], {
      truncate: ellipsis
    }, disabled && 'text-[var(--bds-gray-t4-dis)] cursor-not-allowed', className)
  }, _props), {}, {
    children: children
  }));
};
Text.Title = Title;
Text.Link = Link;
export { Text };